// extracted by mini-css-extract-plugin
export default {"collapsible":"collapsible__collapsible__mc5mm","icon":"collapsible__icon__Ll49b","content":"collapsible__content__Nr1eU"};